import { createAction } from 'redux-actions';
import { RESTORE_USER } from './actionTypes';

/* eslint-disable import/prefer-default-export */
export const restoreUser = createAction(RESTORE_USER);
